/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * Currency of simulated. Must be a valid ISO 4217 currency code. Currently only HKD, USD, EUR are supported.

 */
export type SimulateAuthorizationBodyCurrency = typeof SimulateAuthorizationBodyCurrency[keyof typeof SimulateAuthorizationBodyCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SimulateAuthorizationBodyCurrency = {
  HKD: 'HKD',
  USD: 'USD',
  EUR: 'EUR',
} as const;
